<template>
  <div class="mobile-button-container">
    <v-flex class="mb-16 mobile-button hide">
      <main-button
        depressed
        text="Create email"
        @click="goTo(routes.sportOrganization.sportOrganizationCreateSubscriptionEmail)"
      />
    </v-flex>
    <v-layout column>
      <div class="page-header">
        <v-flex class="title-screen" xs12>
          <span>E-mails to Subscribers</span>
        </v-flex>
        <v-flex class="mb-16 desktop-button">
          <main-button
            depressed
            @click="goTo(routes.sportOrganization.sportOrganizationCreateSubscriptionEmail)"
          >
            <div class="plus-sign">+</div>
            Create email
          </main-button>
        </v-flex>
      </div>
      <v-data-table
        v-model="tableValue"
        :headers="headers"
        :items="items"
        :rows-per-page-items="rowsPerPageItems"
        :rows-per-page-text="isDesktop ? 'Rows per page:' : ''"
        item-key="id"
        disable-initial-sort
        style="border: 1px solid #f5f5f5 !important"
        class="table-container"
      >
        <template slot="items" slot-scope="props">
          <tr
            style="
              position: relative;
              z-index: 4;
              cursor: pointer;
              border: 1px solid #f5f5f5 !important;
            "
          >
            <td>
              <v-flex justify-center align-center>
                <v-switch
                  v-if="props.item.type === 'Automated'"
                  :input-value="props.item.status"
                  color="#ff4c00"
                  style="position: relative; z-index: 1"
                />
                <span v-else class="sent-style">Sent</span>
              </v-flex>
            </td>
            <td>
              <div
                :class="props.item.type === 'Custom' ? 'custom-type-style' : 'automated-type-style'"
              >
                <span>{{ props.item.type }}</span>
              </div>
            </td>
            <td>
              <span v-if="props.item.type === 'Automated'">{{ props.item.sent }}</span>
              <span v-else>{{ props.item.updatedAt }}</span>
            </td>
            <td>{{ props.item.subject }}</td>
            <td>{{ props.item.emailRecipient.recipientType }}</td>
          </tr>
        </template>
        <template slot="no-data"> Create your first referral </template>
      </v-data-table>
    </v-layout>
    <success-snackbar
      :open="wasEmailSent"
      title="Success"
      message="Your email was sent successfully!"
    />
  </div>
</template>

<script>
import SuccessSnackbar from '@/components/shared/snackbars/success-snackbar.vue'
import { GET_ORGANIZATION_SUBSCRIPTION_EMAILS } from '@/graphql/email.graphql'
import { formatDate } from '@/utils'

export default {
  name: 'sport-subscriptions-emails',
  components: {
    SuccessSnackbar,
  },
  props: {
    wasEmailSent: {
      type: Boolean,
      default: () => false,
    },
    organizationSlug: String,
  },
  data() {
    return {
      attendeeFields: [],
      eventAttendeeFields: {},
      showDeleteDialog: false,
      tableValue: [],
      deleteId: undefined,
      isDesktop: false,
      headers: [
        {
          text: 'Status',
          align: 'left',
          sortable: false,
          value: 'status',
        },
        {
          text: 'Type',
          align: 'left',
          sortable: false,
          value: 'type',
        },
        {
          text: 'Sent',
          align: 'left',
          sortable: false,
          value: 'sent',
        },
        {
          text: 'Subject',
          align: 'left',
          sortable: false,
          value: 'subject',
        },
        {
          text: 'Recipients',
          align: 'left',
          sortable: false,
          value: 'recipients',
        },
      ],
      items: [],
      rowsPerPageItems: [5, 10, 25, 100],
    }
  },
  apollo: {
    getOrganizationSubscriptionEmails: {
      query: GET_ORGANIZATION_SUBSCRIPTION_EMAILS,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
        }
      },
      result({ data, loading }) {
        if (!loading) {

          if(!data) {
            return
          }

          const { getOrganizationSubscriptionEmails } = data

          this.items = getOrganizationSubscriptionEmails
            .map(email => {
              return {
                ...email,
                updatedAt: formatDate(email.updatedAt, 'LL H:mm'),
              }
            })
            .sort((a, b) => {
              return a.id - b.id
            })
        }
      },
    },
  },
  created() {
    window.addEventListener('resize', this.resizeHandler)
    if (window.innerWidth > 800) {
      this.isDesktop = true
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    resizeHandler() {
      if (window.innerWidth > 800) {
        this.isDesktop = true
      } else {
        this.isDesktop = false
      }
    },
  },
}
</script>

<style scoped>
.screen-description {
  max-width: 680px;
  margin-bottom: 28px;
}
.automated-type-style {
  width: 81px;
  height: 24px;
  border-radius: 4px;
  background-color: rgba(2, 119, 189, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #0277bd;
}
.custom-type-style {
  width: 61px;
  height: 24px;
  border-radius: 4px;
  background-color: rgba(51, 51, 51, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #333333;
}
.sent-style {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
}
>>> .v-input--selection-controls {
  margin-bottom: 0px !important;
  padding-top: 0px !important;
}
>>> .v-input__slot {
  margin-bottom: 0px !important;
}
>>> .v-messages {
  min-height: 0px !important;
}
.page-header {
  display: flex;
  align-items: flex-end;
}
.plus-sign {
  font-size: 2.25rem;
  font-weight: 100;
  margin-right: 0.625rem;
}
.title-screen {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
@media screen and (max-width: 800px) {
  .title-screen {
    display: none;
  }
}
</style>
